import React from 'react'

const PdfIconNew = () => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='40' height='40' viewBox='0 0 40 40' fill='none'>
      <path
        d='M10 0C8.625 0 7.5 1.125 7.5 2.5V37.5C7.5 38.875 8.625 40 10 40H35C36.375 40 37.5 38.875 37.5 37.5V10L27.5 0H10Z'
        fill='#E2E5E7'
      />
      <path d='M30 10H37.5L27.5 0V7.5C27.5 8.875 28.625 10 30 10Z' fill='#B0B7BD' />
      <path d='M37.5 17.5L30 10H37.5V17.5Z' fill='#CAD1D8' />
      <path
        d='M32.5 32.5C32.5 33.1875 31.9375 33.75 31.25 33.75H3.75C3.0625 33.75 2.5 33.1875 2.5 32.5V20C2.5 19.3125 3.0625 18.75 3.75 18.75H31.25C31.9375 18.75 32.5 19.3125 32.5 20V32.5Z'
        fill='#F15642'
      />
      <path
        d='M7.94629 23.6832C7.94629 23.3532 8.20629 22.9932 8.62504 22.9932H10.9338C12.2338 22.9932 13.4038 23.8632 13.4038 25.5307C13.4038 27.1107 12.2338 27.9907 10.9338 27.9907H9.26504V29.3107C9.26504 29.7507 8.98504 29.9994 8.62504 29.9994C8.29504 29.9994 7.94629 29.7507 7.94629 29.3107V23.6832ZM9.26504 24.2519V26.7419H10.9338C11.6038 26.7419 12.1338 26.1507 12.1338 25.5307C12.1338 24.8319 11.6038 24.2519 10.9338 24.2519H9.26504Z'
        fill='white'
      />
      <path
        d='M15.3624 29.9991C15.0324 29.9991 14.6724 29.8191 14.6724 29.3804V23.7029C14.6724 23.3441 15.0324 23.0829 15.3624 23.0829H17.6511C22.2186 23.0829 22.1186 29.9991 17.7411 29.9991H15.3624ZM15.9924 24.3029V28.7804H17.6511C20.3499 28.7804 20.4699 24.3029 17.6511 24.3029H15.9924Z'
        fill='white'
      />
      <path
        d='M23.7387 24.3829V25.9717H26.2874C26.6474 25.9717 27.0074 26.3317 27.0074 26.6804C27.0074 27.0104 26.6474 27.2804 26.2874 27.2804H23.7387V29.3792C23.7387 29.7292 23.4899 29.9979 23.1399 29.9979C22.6999 29.9979 22.4312 29.7292 22.4312 29.3792V23.7017C22.4312 23.3429 22.7012 23.0817 23.1399 23.0817H26.6487C27.0887 23.0817 27.3487 23.3429 27.3487 23.7017C27.3487 24.0217 27.0887 24.3817 26.6487 24.3817H23.7387V24.3829Z'
        fill='white'
      />
      <path
        d='M31.25 33.75H7.5V35H31.25C31.9375 35 32.5 34.4375 32.5 33.75V32.5C32.5 33.1875 31.9375 33.75 31.25 33.75Z'
        fill='#CAD1D8'
      />
    </svg>
  )
}

export default PdfIconNew
